.subHeaderContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .tabs {
    font-size: 11px;
    white-space: nowrap;
    display: grid;
    grid-template-columns: 1fr 1fr;

    @include themify($themes) {
      background-color: themed("neutral-secondary");
    }

    > div {
      text-align: center;
      padding: 12px 15px;
    }

    > span {
      padding: 12px 0;
    }
  }
}

.searchInput {
  width: 260px;

  input {
    height: 36px;
    border-radius: 20px;
    font-size: 15px;
    padding-left: 45px;
    @include themify($themes) {
      border: 1px solid themed("neutral-secondary");
      background-color: themed("main-secondary");
    }

    &:active,
    &:focus {
      @include themify($themes) {
        border: 1px solid themed("main-primary");
      }

      svg {
        opacity: 1;
      }
    }
  }

  svg {
    opacity: 0.75;
  }

  .clearAllContainer {
    background: transparent;
  }
}

.header {

  &.headerWithError {
    margin-bottom: 0;
  }
}

.headerButtons {
  display: flex;
  align-items: center;
  justify-content: center;

  @include mobile(1700px) {
    margin-left: auto;
  }
}

.headerButtonsSeparator {
  margin: 0 12px;
  @include themify($themes) {
    background-color: themed("neutral-secondary");
  }
  width: 1px;
  height: 22px;
}
